const DATE_FORMATTER = new Intl.DateTimeFormat('ar-MA', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

export function formatPublishedAt(value: string | Date | null | undefined) {
  if (!value) return '';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return '';
  return DATE_FORMATTER.format(d);
}
